import EmailClientContainer from './EmailClient/EmailClientContainer';
import NumeroTelContainer from './NumeroTel/NumeroTelContainer';

const Coordonnees = (props) => {
    const { id } = props;

    return (
        <div id={id}>
            <EmailClientContainer {...props} />
            <NumeroTelContainer {...props} />
        </div>
    );
};

export default Coordonnees;
